<template>
  <div>
    <v-sheet elevation="3" class="mt-6 custom-footer-bnt" rounded>
      <!-- mobile view only -->
      <v-row
          v-if="$vuetify.breakpoint.smAndDown"
          class="mt-n1 mx-0"
          align-content="space-between"
          justify="center"
      >
        <!-- <v-col align-self="center" class="ml-3" cols="3" md="3" sm="3">
          <v-btn
            small
            class="float-right mr-2 mr-md-0 mr-sm-0 btn-help-video pa-4"
            v-show="isSavedLineupButton"
            :color="planType == 'Free' ? '#B0BEC5' : 'success'"
            @click="saveLineup(userId, slateId)"
          >
            Save LineUp
          </v-btn>
        </v-col> -->
        <!-- <v-spacer></v-spacer> -->

        <!--//* build input -->
        <v-col
            cols="3"
            md="3"
            sm="3"
            class="mb-5 mb-md-5 mb-sm-5 ml-2 ml-md-0 ml-sm-0 pa-4"
            align-self="center"
            style="z-index: 9"
        >
          <v-select
              class="maximum float-right"
              :items="NumberOfBuild"
              label="Build No."
              :disabled="planType === 'Free' ? true : false"
              solo
              dense
              v-model="build_no"
          ></v-select>
        </v-col>

        <!--//* build button -->
        <v-col cols="3" md="3" sm="3" v-if="build_no > 150" align-self="center">
          <v-btn
              class="build-btn ml-n3 ml-md-n3 ml-sm-n3 pa-4"
              small
              disabled
              color="info"
          >
            Build Teams
          </v-btn>
        </v-col>
        <v-col cols="3" md="3" sm="3" v-else align-self="center">
          <v-btn
              style="padding: 16px !important; margin-top: 10px"
              class="build-btn ml-n3 ml-md-n3 ml-sm-n3 white--text body-1"
              small
              color="success"
              :loading="isBuilding"
              :disabled="isBuilding"
              @click="checkTodayLineup(true)"
          >
            {{ isBuilding ? 'Generating...' : 'Build Teams' }}
          </v-btn>
        </v-col>
      </v-row>
      <!-- mobile view only ends..-->

      <!--//! error messages -->
      <v-sheet
          v-if="team_build.status == 1 || team_build.status == 2"
          height="810"
          class="error-message"
      >
        <v-row justify="center" class="px-4">
          <v-col class="d-flex justify-center">
            <h3
                v-if="team_build.allTeams == 0"
                class="text-center body-2 py-3 red--text font-weight-bold"
            >
              No Team Build for now !!. <br/>
              Click Build Team to generate.
            </h3>
            <h3
                v-if="team_build.status == 0 && team_build.allTeams.length == 0"
                class="text-center body-2 py-3 red--text font-weight-bold"
            >
              !! No Lineup has been created!<br/>
              Please change your configuration & try again.
            </h3>
            <h3
                v-else-if="team_build.status == 1"
                class="text-center body-2 py-3 red--text font-weight-bold"
            >
              !! No Lineup has been created!<br/>
              Please change your configuration & try again.
            </h3>

            <div v-else-if="team_build.status == 2" class="text-center">
              <img
                  src="/img/green.png"
                  height="150"
                  width="150"
                  alt="referee-warning"
              />
              <h3
                  v-if="operator == 'DraftKings'"
                  class="px-md-10 text-start body-2 py-3 red--text align-center justify-center"
              >
                According to the Community Guidelines of Draftkings: <br/>
                <span class="black--text">
                  when using a lineup builder (like FantasyLineups.com),<br/>
                  a user must

                  <span class="font-weight-bold"
                  >make a minimum of two player modifications.
                  </span>
                </span>
                <br/>
                <span class="text-decoration-underline text-center black--text"
                >Examples</span
                >
                <ul class="black--text">
                  <li>Exclude 2 or more players</li>
                  <li>Lock 2 or more players</li>
                  <li>Change the Min/Max of 2 or more players</li>
                  <li>Exclude 1 player + Lock 1 player</li>
                  <li>Change Min/Max of 1 player + exclude 1 player</li>
                </ul>
                <span
                    class="caption text-center black--text font-weight-bold"
                    v-if="$vuetify.breakpoint.smAndDown"
                >
                  Click the blue Player Pool button to try again
                </span>
              </h3>

              <h3
                  v-else
                  class="text-center body-2 py-3 red--text font-weight-bold"
              >
                !! Please lock atleast one player &<br/>
                then try again.
              </h3>
            </div>
          </v-col>
        </v-row>
      </v-sheet>
      <!--//! error messages ends...-->

      <!-- Skeleton loader when building from internal button -->
      <v-row v-if="isBuilding" class="mx-1">
        <v-col cols="12" md="12" sm="12" class="mb-5 mt-4" style="height: 880px; overflow-y: scroll">
          <!-- Build counter skeleton -->
          <v-row align="center" class="mx-2 mb-4" justify="space-between">
            <v-skeleton-loader type="text" width="150" class="skeleton-fade"></v-skeleton-loader>
          </v-row>
          
          <!-- Team selection skeleton -->
          <v-row align="center" class="mb-4">
            <v-skeleton-loader type="text" width="120" class="skeleton-fade"></v-skeleton-loader>
            <v-spacer></v-spacer>
            <v-skeleton-loader type="button" width="100" class="skeleton-fade"></v-skeleton-loader>
          </v-row>

          <!-- Team cards skeleton - responsive count based on screen size -->
          <div v-for="n in ($vuetify.breakpoint.smAndDown ? 3 : 5)" :key="n" class="mt-4 mb-4">
            <!-- Team header skeleton -->
            <v-skeleton-loader 
              type="card-heading" 
              class="mb-2 skeleton-fade"
              :style="{ animationDelay: (n * 0.2) + 's' }"
            ></v-skeleton-loader>
            
            <!-- Team table skeleton -->
            <v-card class="elevation-1 skeleton-fade" :style="{ animationDelay: (n * 0.3) + 's' }">
              <v-card-text class="pa-2">
                <div v-for="row in (defaultSport == '1' ? 8 : defaultSport == '2' ? 10 : defaultSport == '3' ? 9 : 9)" :key="row" class="d-flex align-center py-2">
                  <v-skeleton-loader type="avatar" class="mr-2" width="37" height="48"></v-skeleton-loader>
                  <v-skeleton-loader type="button" width="30" class="mr-2"></v-skeleton-loader>
                  <v-skeleton-loader type="text" width="40" class="mr-3"></v-skeleton-loader>
                  <v-skeleton-loader type="text" width="50" class="mr-3"></v-skeleton-loader>
                  <v-skeleton-loader type="chip" class="mr-3"></v-skeleton-loader>
                  <v-skeleton-loader type="text" width="60" class="mr-3"></v-skeleton-loader>
                  <v-skeleton-loader type="text" width="40" class="mr-3"></v-skeleton-loader>
                  <v-skeleton-loader type="text" width="40"></v-skeleton-loader>
                </div>
              </v-card-text>
              
              <!-- Footer skeleton -->
              <v-card-actions class="pa-3">
                <v-skeleton-loader type="text" width="120" class="mr-4"></v-skeleton-loader>
                <v-spacer></v-spacer>
                <v-skeleton-loader type="text" width="100"></v-skeleton-loader>
              </v-card-actions>
            </v-card>
          </div>
        </v-col>
      </v-row>

      <v-row v-else-if="!isBuilding" :key="componentKey" class="mx-1">
        <!-- team table -->
        <v-col
            cols="12"
            md="12"
            sm="12"
            class="mb-5 mt-4"
            style="height: 880px; overflow-y: scroll"
        >
          <v-row align="center" class="mx-2" justify="space-between">
            <!--? build counter -->
            <p v-if="!$vuetify.breakpoint.smAndDown">
              Lineups:
              <span class="green--text">
                {{ currentBuildSize ? currentBuildSize : `0` }}
              </span>
              out of
              <span class="font-weight-medium">
                {{
                  $vuetify.breakpoint.smAndDown
                      ? build_no
                      : NumberOfBuildDesktop
                }}
              </span>
            </p>
            <!--? build counter ends-->
          </v-row>

          <v-row align="center">
            <!-- selection for all team to save lineup -->
            <div class="py-2">
              <label
                  class="selection-container body-2 font-weight-bold mb-1 mr-3"
                  v-show="team_build.allTeams"
              >
                &nbsp; Select All Teams
                <input
                    v-show="false"
                    type="checkbox"
                    v-model="select_all"
                    @change="selectAllToggle"
                />
                <span v-show="false" class="checkmark"></span>
              </label>
            </div>

            <v-spacer></v-spacer>

            <!-- selection fo all team to save lineup end-->
            <div class="mx-4">
              <v-btn
                  small
                  style="padding: 10px !important"
                  class="float-right mr-2 mr-md-0 mr-sm-0"
                  v-show="isSavedLineupButton"
                  :color="planType == 'Free' ? '#B0BEC5' : 'success'"
                  @click="saveLineup(userId, slateId)"
              >
                Save Lineup
              </v-btn>
            </div>
          </v-row>

          <!-- //* TABLE loop start  -->
          <template>
            <v-virtual-scroll
                class="mt-3"
                :items="setLineups"
                :item-height="computedItemHeight"
                height="1500"
            >
              <template v-slot:default="data">
                <div class="mt-2 mb-2">
                  <label class="selection-container">
                    <input
                        type="checkbox"
                        :value="data.index"
                        id="selected_team"
                        :checked="isChecked"
                        @change="singleTeamSelection(data.item, data.index)"
                    />
                    <span class="checkmark"></span>
                  </label>

                  <base-title-bar
                      elevation="3"
                      class="text-center"
                      color="#17408B"
                      :label="'Team' + ' ' + (data.index + 1)"
                      icon="mdi-star"
                  />

                  <v-data-table
                      :headers="TeamHeaders"
                      :items="data.item"
                      :item-key="data.item.PlayerID + guid()"
                      class="elevation-1 new-team-stack-table"
                      :items-per-page="data.item.length"
                      hide-default-footer
                      mobile-breakpoint="0"
                  >
                    <!-- position -->
                    <template v-slot:item.DraftKingsPosition="{ index }">
                      <!-- //todo Nba.. -->
                      <template
                          v-if="
                          operator == 'DraftKings' &&
                          operatorGameType == 'Classic' &&
                          defaultSport == '1'
                        "
                      >
                        <p class="caption" v-if="index == 0">PG</p>
                        <p class="caption" v-if="index == 1">SG</p>
                        <p class="caption" v-if="index == 2">SF</p>
                        <p class="caption" v-if="index == 3">PF</p>
                        <p class="caption" v-if="index == 4">C</p>
                        <p class="caption" v-if="index == 5">G</p>
                        <p class="caption" v-if="index == 6">F</p>
                        <p class="caption" v-if="index == 7">UTIL</p>
                      </template>

                      <template
                          v-else-if="
                          operator == 'DraftKings' &&
                          operatorGameType == 'Single' &&
                          defaultSport == '1'
                        "
                      >
                        <p class="caption" v-if="index == 0">CPT</p>
                        <p class="caption" v-if="index == 1">UTIL</p>
                        <p class="caption" v-if="index == 2">UTIL</p>
                        <p class="caption" v-if="index == 3">UTIL</p>
                        <p class="caption" v-if="index == 4">UTIL</p>
                        <p class="caption" v-if="index == 5">UTIL</p>
                      </template>

                      <template
                          v-if="
                          operator == 'FanDuel' &&
                          operatorGameType == 'Classic' &&
                          defaultSport == '1'
                        "
                      >
                        <p class="caption" v-if="index == 0">PG</p>
                        <p class="caption" v-if="index == 1">PG</p>
                        <p class="caption" v-if="index == 2">SG</p>
                        <p class="caption" v-if="index == 3">SG</p>
                        <p class="caption" v-if="index == 4">SF</p>
                        <p class="caption" v-if="index == 5">SF</p>
                        <p class="caption" v-if="index == 6">PF</p>
                        <p class="caption" v-if="index == 7">PF</p>
                        <p class="caption" v-if="index == 8">C</p>
                      </template>

                      <template
                          v-if="
                          operator == 'FanDuel' &&
                          operatorGameType == 'Single' &&
                          defaultSport == '1'
                        "
                      >
                        <p class="caption" v-if="index == 0">MVP</p>
                        <p class="caption" v-if="index == 1">STAR</p>
                        <p class="caption" v-if="index == 2">PRO</p>
                        <p class="caption" v-if="index == 3">UTIL</p>
                        <p class="caption" v-if="index == 4">UTIL2</p>
                      </template>
                      <!-- //todo Nba ends.. -->

                      <!-- //todo Mlb... -->
                      <template
                          v-if="
                          operator == 'DraftKings' &&
                          operatorGameType == 'Classic' &&
                          defaultSport == '2'
                        "
                      >
                        <p class="caption" v-if="index == 0">P</p>
                        <p class="caption" v-if="index == 1">P</p>
                        <p class="caption" v-if="index == 2">C</p>
                        <p class="caption" v-if="index == 3">1B</p>
                        <p class="caption" v-if="index == 4">2B</p>
                        <p class="caption" v-if="index == 5">3B</p>
                        <p class="caption" v-if="index == 6">SS</p>
                        <p class="caption" v-if="index == 7">OF</p>
                        <p class="caption" v-if="index == 8">OF</p>
                        <p class="caption" v-if="index == 9">OF</p>
                      </template>

                      <template
                          v-if="
                          operator == 'DraftKings' &&
                          operatorGameType == 'Single' &&
                          defaultSport == '2'
                        "
                      >
                        <p class="caption" v-if="index == 0">CPT</p>
                        <p class="caption" v-if="index == 1">UTIL</p>
                        <p class="caption" v-if="index == 2">UTIL</p>
                        <p class="caption" v-if="index == 3">UTIL</p>
                        <p class="caption" v-if="index == 4">UTIL</p>
                        <p class="caption" v-if="index == 5">UTIL</p>
                      </template>

                      <template
                          v-if="
                          operator == 'FanDuel' &&
                          operatorGameType == 'Classic' &&
                          defaultSport == '2'
                        "
                      >
                        <p class="caption" v-if="index == 0">P</p>
                        <p class="caption" v-if="index == 1">C/1B</p>
                        <p class="caption" v-if="index == 2">2B</p>
                        <p class="caption" v-if="index == 3">3B</p>
                        <p class="caption" v-if="index == 4">SS</p>
                        <p class="caption" v-if="index == 5">OF</p>
                        <p class="caption" v-if="index == 6">OF</p>
                        <p class="caption" v-if="index == 7">OF</p>
                        <p class="caption" v-if="index == 8">UTIL</p>
                      </template>

                      <template
                          v-if="
                          operator == 'FanDuel' &&
                          operatorGameType == 'Single' &&
                          defaultSport == '2'
                        "
                      >
                        <p class="caption" v-if="index == 0">MVP</p>
                        <p class="caption" v-if="index == 1">STAR</p>
                        <p class="caption" v-if="index == 2">UTIL</p>
                        <p class="caption" v-if="index == 3">UTIL</p>
                        <p class="caption" v-if="index == 4">UTIL</p>
                        <p class="caption" v-if="index == 5">UTIL</p>
                        <p class="caption" v-if="index == 6">UTIL</p>
                      </template>
                      <!-- //todo Mlb ends... -->

                      <!-- //todo Nhl.. -->
                      <template
                          v-if="
                          operator == 'DraftKings' &&
                          operatorGameType == 'Classic' &&
                          defaultSport == '3'
                        "
                      >
                        <p class="caption" v-if="index == 0">C</p>
                        <p class="caption" v-if="index == 1">C</p>
                        <p class="caption" v-if="index == 2">W</p>
                        <p class="caption" v-if="index == 3">W</p>
                        <p class="caption" v-if="index == 4">W</p>
                        <p class="caption" v-if="index == 5">D</p>
                        <p class="caption" v-if="index == 6">D</p>
                        <p class="caption" v-if="index == 7">G</p>
                        <p class="caption" v-if="index == 8">UTIL</p>
                      </template>

                      <template
                          v-if="
                          operator == 'DraftKings' &&
                          operatorGameType == 'Single' &&
                          defaultSport == '3'
                        "
                      >
                        <p class="caption" v-if="index == 0">CPT</p>
                        <p class="caption" v-if="index == 1">Flex</p>
                        <p class="caption" v-if="index == 2">Flex</p>
                        <p class="caption" v-if="index == 3">Flex</p>
                        <p class="caption" v-if="index == 4">Flex</p>
                        <p class="caption" v-if="index == 5">Flex</p>
                      </template>

                      <template
                          v-if="
                          operator == 'FanDuel' &&
                          operatorGameType == 'Classic' &&
                          defaultSport == '3'
                        "
                      >
                        <p class="caption" v-if="index == 0">C</p>
                        <p class="caption" v-if="index == 1">C</p>
                        <p class="caption" v-if="index == 2">W</p>
                        <p class="caption" v-if="index == 3">W</p>
                        <p class="caption" v-if="index == 4">D</p>
                        <p class="caption" v-if="index == 5">D</p>
                        <p class="caption" v-if="index == 6">Util</p>
                        <p class="caption" v-if="index == 7">Util</p>
                        <p class="caption" v-if="index == 8">G</p>
                      </template>

                      <template
                          v-if="
                          operator == 'FanDuel' &&
                          operatorGameType == 'Single' &&
                          defaultSport == '3'
                        "
                      >
                        <p class="caption" v-if="index == 0">CPT</p>
                        <p class="caption" v-if="index == 1">UTIL</p>
                        <p class="caption" v-if="index == 2">UTIL</p>
                        <p class="caption" v-if="index == 3">UTIL</p>
                        <p class="caption" v-if="index == 4">UTIL</p>
                      </template>
                      <!-- //todo Nhl ends.. -->

                      <!-- //todo Nfl starts -->
                      <template
                          v-if="
                          operator == 'DraftKings' &&
                          operatorGameType == 'Classic' &&
                          defaultSport == '4'
                        "
                      >
                        <p class="caption" v-if="index == 0">QB</p>
                        <p class="caption" v-if="index == 1">RB</p>
                        <p class="caption" v-if="index == 2">RB</p>
                        <p class="caption" v-if="index == 3">WR</p>
                        <p class="caption" v-if="index == 4">WR</p>
                        <p class="caption" v-if="index == 5">WR</p>
                        <p class="caption" v-if="index == 6">TE</p>
                        <p class="caption" v-if="index == 7">FLEX</p>
                        <p class="caption" v-if="index == 8">DST</p>
                      </template>

                      <template
                          v-if="
                          operator == 'DraftKings' &&
                          operatorGameType == 'Single' &&
                          defaultSport == '4'
                        "
                      >
                        <p class="caption" v-if="index == 0">CPT</p>
                        <p class="caption" v-if="index == 1">FLEX</p>
                        <p class="caption" v-if="index == 2">FLEX</p>
                        <p class="caption" v-if="index == 3">FLEX</p>
                        <p class="caption" v-if="index == 4">FLEX</p>
                        <p class="caption" v-if="index == 5">FLEX</p>
                      </template>

                      <template
                          v-if="
                          operator == 'FanDuel' &&
                          operatorGameType == 'Classic' &&
                          defaultSport == '4'
                        "
                      >
                        <p class="caption" v-if="index == 0">QB</p>
                        <p class="caption" v-if="index == 1">RB</p>
                        <p class="caption" v-if="index == 2">RB</p>
                        <p class="caption" v-if="index == 3">WR</p>
                        <p class="caption" v-if="index == 4">WR</p>
                        <p class="caption" v-if="index == 5">WR</p>
                        <p class="caption" v-if="index == 6">TE</p>
                        <p class="caption" v-if="index == 7">FLEX</p>
                        <p class="caption" v-if="index == 8">DEF</p>
                      </template>

                      <template
                          v-if="
                          operator === 'FanDuel' &&
                          operatorGameType === 'Single' &&
                          defaultSport === '4'
                        "
                      >
                        <p class="caption" v-if="index === 0">MVP</p>
                        <p class="caption" v-if="index === 1">FLEX</p>
                        <p class="caption" v-if="index === 2">FLEX</p>
                        <p class="caption" v-if="index === 3">FLEX</p>
                        <p class="caption" v-if="index === 4">FLEX</p>
                        <p class="caption" v-if="index === 5">FLEX</p>
                      </template>
                      <!-- //todo Nfl ends -->
                    </template>
                    <!-- position-->

                    <!-- OpponentRank -->
                    <template v-slot:item.OpponentRank="{ item }" class="mt-1">
                      <v-avatar size="25" rounded>
                        <v-icon>mdi-account-group-outline</v-icon>
                      </v-avatar>
                      <p class="ml-1">{{ item.OpponentRank }}</p>
                    </template>
                    <!-- OpponentRank ends -->

                    <!-- OpponentPositionRank -->
                    <template
                        v-slot:item.OpponentPositionRank="{ item }"
                        class="mt-1"
                    >
                      <v-avatar size="25" rounded>
                        <v-icon>mdi-shield-account-outline</v-icon>
                      </v-avatar>
                      <p class="ml-1">{{ item.OpponentPositionRank }}</p>
                    </template>
                    <!-- OpponentPositionRank ends -->

                    <!-- profile image -->
                    <template v-slot:item.PhotoUrl="{ item }">
                      <div>
                        <v-avatar v-if="item.PhotoUrl" width="37" height="48">
                          <img :src="item.PhotoUrl"/>
                        </v-avatar>

                        <v-avatar
                            v-if="!item.PhotoUrl && defaultSport == 4"
                            width="37"
                            height="48"
                        >
                          <img
                              alt="No image"
                              src="/img/fallback_image.png"
                          /><img src="/DEN.svg"/>
                        </v-avatar>
                      </div>

                      <div>
                        <p class="caption" v-if="item.Name === null">
                          {{ item.Team }}
                        </p>
                      </div>

                      <!--//* player detailsModal -->
                      <v-dialog
                          fullscreen
                          hide-overlay
                          transition="dialog-bottom-transition"
                          v-model="item.PLayerDialog"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <a
                              v-on="on"
                              v-bind="attrs"
                              class="caption"
                              @click="
                              playerDetailModal(item.PlayerID, item.SportId)
                            "
                          >
                            {{ item.Name }}
                          </a>
                        </template>

                        <v-card>
                          <v-toolbar dark color="#57bc90" flat>
                            <v-btn icon dark @click="item.PLayerDialog = false">
                              <v-icon>mdi-close</v-icon>
                            </v-btn>
                            <v-toolbar-title>Player Details</v-toolbar-title>
                          </v-toolbar>
                          <player-details
                              :playerId="playerId"
                              :SportId="sportsID"
                          />
                        </v-card>
                      </v-dialog>
                      <!--//* player detailsModal ends...-->
                    </template>
                    <!-- profile image ends -->

                    <!-- matchup -->
                    <template v-slot:item.Team="{ item }">
                      <p>{{ item.Team }}&nbsp;</p>
                    </template>
                    <!-- matchup ends -->

                    <template v-slot:item.HomeOrAway="{ item }">
                      <!-- Blue dot - 'active',
                    green dot - 'positive',
                    yellow dot -'intermediary'
                    red dot - 'negative' -->

                      <v-row>
                        <v-tooltip top>
                          <template v-slot:activator="{ on, attrs }">
                            <v-col
                                cols="2"
                                md="3"
                                sm="1"
                                v-show="item.InjuryStatus == null"
                                v-on="on"
                                v-bind="attrs"
                            >
                              <status-indicator status="positive" pulse/>
                            </v-col>
                          </template>
                          <span>Healthy</span>
                        </v-tooltip>

                        <v-tooltip top>
                          <template v-slot:activator="{ on, attrs }">
                            <v-col
                                cols="2"
                                md="3"
                                sm="1"
                                v-show="item.InjuryStatus == 'Out'"
                                v-on="on"
                                v-bind="attrs"
                            >
                              <status-indicator status="negative" pulse/>
                            </v-col>
                          </template>
                          <span>Out</span>
                        </v-tooltip>

                        <v-tooltip top>
                          <template v-slot:activator="{ on, attrs }">
                            <v-col
                                cols="2"
                                md="3"
                                sm="1"
                                v-on="on"
                                v-bind="attrs"
                                v-show="item.InjuryStatus == 'Questionable'"
                            >
                              <status-indicator status="intermediary" pulse/>
                            </v-col>
                          </template>
                          <span>Questionable</span>
                        </v-tooltip>

                        <v-tooltip top>
                          <template v-slot:activator="{ on, attrs }">
                            <v-col
                                cols="2"
                                md="3"
                                sm="1"
                                v-on="on"
                                v-bind="attrs"
                                v-show="
                                item.InjuryStatus == 'Probable' ||
                                item.InjuryStatus == 'Doubtful'
                              "
                            >
                              <status-indicator status="active" pulse/>
                            </v-col>
                          </template>
                          <span>Probable</span>
                        </v-tooltip>

                        <v-tooltip top>
                          <template v-slot:activator="{ on, attrs }">
                            <v-col
                                cols="2"
                                md="3"
                                sm="1"
                                v-on="on"
                                v-bind="attrs"
                                v-show="item.HomeOrAway == 'HOME'"
                            >
                              <status-indicator status="positive" pulse/>
                            </v-col>
                          </template>
                          <span>HOME</span>
                        </v-tooltip>

                        <v-tooltip top>
                          <template v-slot:activator="{ on }">
                            <v-col
                                cols="2"
                                md="3"
                                sm="1"
                                v-on="on"
                                v-show="item.HomeOrAway == 'AWAY'"
                            >
                              <status-indicator status="negative" pulse/>
                            </v-col>
                          </template>
                          <span>AWAY</span>
                        </v-tooltip>
                      </v-row>
                    </template>

                    <!-- salary -->
                    <template v-slot:item.DraftKingsSalary="{ item }">
                      <p
                          v-if="operator == 'DraftKings'"
                          class="caption green--text"
                      >
                        {{ item.DraftKingsSalary }}
                      </p>
                      <p
                          v-if="operator == 'FanDuel'"
                          class="caption green--text"
                      >
                        {{ item.FanDuelSalary }}
                      </p>
                    </template>
                    <!-- salary ends -->

                    <!-- FPPG -->
                    <template v-slot:item.FPPG="{ item }">
                      <p class="caption">{{ item.FPPG >> 0 }}</p>
                    </template>
                    <!-- FPPG -->

                    <!-- projection -->
                    <template v-slot:item.DraftKingsProjection="{ item }">
                      <p v-if="operator == 'DraftKings'" class="caption">
                        {{ item.DraftKingsProjection }}
                      </p>
                      <p v-else class="caption">
                        {{ item.FandDualProjection }}
                      </p>
                    </template>
                    <!-- projection ends -->

                    <!-- swap action -->
                    <template v-slot:item.swap="{ item, index }">
                      <v-dialog v-model="item.dialog" width="500">
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                              x-small
                              fab
                              color="blue"
                              dark
                              class="mr-4"
                              v-on="on"
                              v-bind="attrs"
                              @click="
                              getPlayersByIndex(
                                index,
                                item,
                                data.index,
                                slateId,
                                item.DraftKingsPosition
                              )
                            "
                          >
                            <v-icon>mdi-swap-horizontal</v-icon>
                          </v-btn>
                        </template>

                        <!--//! for draftkings only -->
                        <v-list
                            v-if="operator == 'DraftKings'"
                            class="build-teams-popup"
                        >
                          <v-list-item-group active-class="green--text">
                            <template v-for="(option_player, index) in Arr">
                              <!-- players 2 -->
                              <v-list-item
                                  :key="index"
                                  v-if="
                                  remainingAmount >=
                                  option_player.DraftKingsSalary
                                "
                                  @click="
                                  replacePlayer(
                                    option_player,
                                    item.PlayerID,
                                    data.index
                                  )
                                "
                              >
                                <template v-slot:default="{ active }">
                                  <v-list-item-content>
                                    <v-row justify="center" class="mx-auto">
                                      <v-col
                                          cols="2"
                                          md="2"
                                          sm="2"
                                          class="div-width d-none d-sm-block"
                                      >
                                        <v-list-item-avatar rounded>
                                          <v-avatar width="37" height="48">
                                            <img
                                                :src="option_player.PhotoUrl"
                                            />
                                          </v-avatar>
                                        </v-list-item-avatar>
                                      </v-col>
                                      <v-col
                                          cols="3"
                                          md="3"
                                          sm="3"
                                          class="div-width"
                                      >
                                        <v-list-item-title
                                            class="caption mt-4"
                                            v-text="option_player.Name"
                                        >
                                        </v-list-item-title>
                                        <!-- <p>{{ index + 1 }}</p> -->
                                      </v-col>
                                      <!-- salary -->
                                      <v-col
                                          cols="3"
                                          md="3"
                                          sm="3"
                                          class="div-width"
                                      >
                                        <v-list-item-subtitle
                                            class="mt-1 body-1 mt-4"
                                            v-if="operator == 'DraftKings'"
                                            v-text="
                                            `$ ${option_player.DraftKingsSalary}`
                                          "
                                        ></v-list-item-subtitle>
                                        <v-list-item-subtitle
                                            class="mt-1 body-1"
                                            v-if="operator == 'FanDuel'"
                                            v-text="
                                            `$ ${option_player.FanDuelSalary}`
                                          "
                                        ></v-list-item-subtitle>
                                      </v-col>

                                      <!-- projection -->
                                      <v-col
                                          cols="3"
                                          md="3"
                                          sm="3"
                                          class="div-width"
                                      >
                                        <v-list-item-subtitle
                                            class="mt-1 body-1 mt-4"
                                            v-if="operator == 'DraftKings'"
                                            v-text="
                                            `${option_player.DraftKingsProjection}`
                                          "
                                        ></v-list-item-subtitle>
                                        <v-list-item-subtitle
                                            class="mt-1 body-1 mt-4"
                                            v-if="operator == 'FanDuel'"
                                            v-text="
                                            `${option_player.FandDualProjection}`
                                          "
                                        ></v-list-item-subtitle>
                                      </v-col>
                                      <v-col
                                          cols="1"
                                          md="1"
                                          sm="1"
                                          class="div-width"
                                      >
                                        <v-list-item-action>
                                          <v-icon
                                              v-if="!active"
                                              color="green lighten-1"
                                          >mdi-tray-plus
                                          </v-icon>
                                        </v-list-item-action>
                                      </v-col>
                                    </v-row>
                                  </v-list-item-content>
                                </template>
                              </v-list-item>

                              <!-- players 1 -->
                              <v-list-item
                                  :key="index"
                                  v-if="
                                  remainingAmount <
                                  option_player.DraftKingsSalary
                                "
                                  disabled
                                  color="grey"
                                  @click="
                                  replacePlayer(
                                    option_player,
                                    item.PlayerID,
                                    data.index
                                  )
                                "
                              >
                                <template v-slot:default="{ active }">
                                  <v-list-item-content>
                                    <v-row justify="center" class="mx-auto">
                                      <v-col
                                          cols="2"
                                          md="2"
                                          sm="2"
                                          class="div-width d-none d-sm-block"
                                      >
                                        <v-list-item-avatar rounded>
                                          <v-avatar width="37" height="48">
                                            <img
                                                :src="option_player.PhotoUrl"
                                            />
                                          </v-avatar>
                                        </v-list-item-avatar>
                                      </v-col>
                                      <v-col
                                          cols="3"
                                          md="3"
                                          sm="3"
                                          class="div-width"
                                      >
                                        <v-list-item-title
                                            class="caption mt-4"
                                            v-text="option_player.Name"
                                        ></v-list-item-title>
                                        <!-- <p>{{ index + 1 }}</p> -->
                                      </v-col>

                                      <!-- salary -->
                                      <v-col
                                          cols="3"
                                          md="3"
                                          sm="3"
                                          class="div-width"
                                      >
                                        <v-list-item-subtitle
                                            class="mt-1 body-1 mt-4"
                                            v-if="operator == 'DraftKings'"
                                            v-text="
                                            `$ ${option_player.DraftKingsSalary}`
                                          "
                                        ></v-list-item-subtitle>
                                        <v-list-item-subtitle
                                            class="mt-1 body-1 mt-4"
                                            v-if="operator == 'FanDuel'"
                                            v-text="
                                            `$ ${option_player.FanDuelSalary}`
                                          "
                                        ></v-list-item-subtitle>
                                      </v-col>

                                      <!-- projection -->
                                      <v-col
                                          cols="3"
                                          md="3"
                                          sm="3"
                                          class="div-width"
                                      >
                                        <v-list-item-subtitle
                                            class="mt-1 body-1 mt-4"
                                            v-if="operator == 'DraftKings'"
                                            v-text="
                                            `${option_player.DraftKingsProjection}`
                                          "
                                        ></v-list-item-subtitle>
                                        <v-list-item-subtitle
                                            class="mt-1 body-1 mt-4"
                                            v-if="operator == 'FanDuel'"
                                            v-text="
                                            `${option_player.FandDualProjection}`
                                          "
                                        ></v-list-item-subtitle>
                                      </v-col>
                                      <v-col
                                          cols="1"
                                          md="1"
                                          sm="1"
                                          class="div-width"
                                      >
                                        <v-list-item-action>
                                          <v-icon
                                              v-if="!active"
                                              color="red lighten-1"
                                          >mdi-tray-remove
                                          </v-icon>
                                        </v-list-item-action>
                                      </v-col>
                                    </v-row>
                                  </v-list-item-content>
                                </template>
                              </v-list-item>

                              <v-divider
                                  v-if="index < option_player.length - 1"
                                  :key="index"
                              ></v-divider>
                            </template>
                          </v-list-item-group>
                        </v-list>

                        <!--//! for fanduel only -->
                        <v-list
                            v-if="operator == 'FanDuel'"
                            class="build-teams-popup"
                        >
                          <v-list-item-group active-class="green--text">
                            <template v-for="(option_player, index) in Arr">
                              <!-- players 1 -->
                              <v-list-item
                                  :key="index"
                                  v-if="
                                  remainingAmount < option_player.FanDuelSalary
                                "
                                  disabled
                                  color="grey"
                                  @click="
                                  replacePlayer(
                                    option_player,
                                    item.PlayerID,
                                    data.index
                                  )
                                "
                              >
                                <template v-slot:default="{ active }">
                                  <v-list-item-content>
                                    <v-row class="mx-auto">
                                      <v-col
                                          cols="2"
                                          md="2"
                                          sm="2"
                                          class="div-width d-none d-sm-block"
                                      >
                                        <v-list-item-avatar rounded>
                                          <v-avatar width="37" height="48">
                                            <img
                                                :src="option_player.PhotoUrl"
                                            />
                                          </v-avatar>
                                        </v-list-item-avatar>
                                      </v-col>
                                      <v-col
                                          cols="3"
                                          md="3"
                                          sm="3"
                                          class="div-width"
                                      >
                                        <v-list-item-title
                                            class="caption mt-4"
                                            v-text="option_player.Name"
                                        ></v-list-item-title>
                                        <!-- <p>{{ index + 1 }}</p> -->
                                      </v-col>
                                      <!-- salary -->
                                      <v-col
                                          cols="3"
                                          md="3"
                                          sm="3"
                                          class="div-width"
                                      >
                                        <v-list-item-subtitle
                                            class="mt-1 body-1 mt-4"
                                            v-if="operator == 'DraftKings'"
                                            v-text="
                                            `$ ${option_player.DraftKingsSalary}`
                                          "
                                        ></v-list-item-subtitle>
                                        <v-list-item-subtitle
                                            class="mt-1 body-1 mt-4"
                                            v-if="operator == 'FanDuel'"
                                            v-text="
                                            `$ ${option_player.FanDuelSalary}`
                                          "
                                        ></v-list-item-subtitle>
                                      </v-col>
                                      <!-- projection -->
                                      <v-col
                                          cols="3"
                                          md="3"
                                          sm="3"
                                          class="div-width"
                                      >
                                        <v-list-item-subtitle
                                            class="mt-1 body-1 mt-4"
                                            v-if="operator == 'DraftKings'"
                                            v-text="
                                            `${option_player.DraftKingsProjection}`
                                          "
                                        ></v-list-item-subtitle>
                                        <v-list-item-subtitle
                                            class="mt-1 body-1 mt-4"
                                            v-if="operator == 'FanDuel'"
                                            v-text="
                                            `${option_player.FandDualProjection}`
                                          "
                                        ></v-list-item-subtitle>
                                      </v-col>
                                      <v-col
                                          cols="1"
                                          md="1"
                                          sm="1"
                                          class="div-width"
                                      >
                                        <v-list-item-action>
                                          <v-icon
                                              v-if="!active"
                                              color="red lighten-1"
                                          >mdi-tray-remove
                                          </v-icon>
                                        </v-list-item-action>
                                      </v-col>
                                    </v-row>
                                  </v-list-item-content>
                                </template>
                              </v-list-item>

                              <!-- players 2 -->
                              <v-list-item
                                  :key="index"
                                  v-if="
                                  remainingAmount >= option_player.FanDuelSalary
                                "
                                  @click="
                                  replacePlayer(
                                    option_player,
                                    item.PlayerID,
                                    data.index
                                  )
                                "
                              >
                                <template v-slot:default="{ active }">
                                  <v-list-item-content>
                                    <v-row class="mx-auto">
                                      <v-col
                                          cols="2"
                                          md="2"
                                          sm="2"
                                          class="div-width d-none d-sm-block"
                                      >
                                        <v-list-item-avatar rounded>
                                          <v-avatar width="37" height="48">
                                            <img
                                                :src="option_player.PhotoUrl"
                                            />
                                          </v-avatar>
                                        </v-list-item-avatar>
                                      </v-col>
                                      <v-col
                                          cols="3"
                                          md="3"
                                          sm="3"
                                          class="div-width"
                                      >
                                        <v-list-item-title
                                            class="caption mt-4"
                                            v-text="option_player.Name"
                                        ></v-list-item-title>
                                        <!-- <p>{{ index + 1 }}</p> -->
                                      </v-col>

                                      <!-- salary -->
                                      <v-col
                                          cols="3"
                                          md="3"
                                          sm="3"
                                          class="div-width"
                                      >
                                        <v-list-item-subtitle
                                            class="mt-1 body-1 mt-4"
                                            v-if="operator == 'DraftKings'"
                                            v-text="
                                            `$ ${option_player.DraftKingsSalary}`
                                          "
                                        ></v-list-item-subtitle>
                                        <v-list-item-subtitle
                                            class="mt-1 body-1 mt-4"
                                            v-if="operator == 'FanDuel'"
                                            v-text="
                                            `$ ${option_player.FanDuelSalary}`
                                          "
                                        ></v-list-item-subtitle>
                                      </v-col>

                                      <!-- projection -->
                                      <v-col
                                          cols="3"
                                          md="3"
                                          sm="3"
                                          class="div-width"
                                      >
                                        <v-list-item-subtitle
                                            class="mt-1 body-1 mt-4"
                                            v-if="operator == 'DraftKings'"
                                            v-text="
                                            `${option_player.DraftKingsProjection}`
                                          "
                                        ></v-list-item-subtitle>
                                        <v-list-item-subtitle
                                            class="mt-1 body-1 mt-4"
                                            v-if="operator == 'FanDuel'"
                                            v-text="
                                            `${option_player.FandDualProjection}`
                                          "
                                        ></v-list-item-subtitle>
                                      </v-col>
                                      <v-col
                                          cols="1"
                                          md="1"
                                          sm="1"
                                          class="div-width"
                                      >
                                        <v-list-item-action>
                                          <v-icon
                                              v-if="!active"
                                              color="green lighten-1"
                                          >
                                            mdi-tray-plus
                                          </v-icon>
                                        </v-list-item-action>
                                      </v-col>
                                    </v-row>
                                  </v-list-item-content>
                                </template>
                              </v-list-item>
                              <v-divider
                                  v-if="index < option_player.length - 1"
                                  :key="index"
                              ></v-divider>
                            </template>
                          </v-list-item-group>
                        </v-list>
                        <v-divider></v-divider>
                        <v-card-actions>
                          <v-spacer></v-spacer>
                          <v-btn
                              color="red"
                              outlined
                              text
                              @click="item.dialog = false"
                          >
                            Cancel
                          </v-btn>
                        </v-card-actions>
                      </v-dialog>
                    </template>
                    <!-- swap action ends-->

                    <!-- footer -->
                    <template v-slot:footer="{}">
                      <v-sheet elevation="1">
                        <!-- //? for Draftkings -->
                        <template v-if="operator == 'DraftKings'">
                          <v-row>
                            <v-col>
                              <p class="body-2 mx-2 my-2 pa-4">
                                Total Salary:
                                <span
                                    v-if="calculateSalary(data.index) <= 50000"
                                    class="green--text body-2"
                                >
                                  $ {{ calculateSalary(data.index) }}
                                </span>
                                <span
                                    v-if="calculateSalary(data.index) > 50000"
                                    class="red--text body-2"
                                >
                                  $ {{ calculateSalary(data.index) }}
                                </span>
                              </p></v-col
                            >
                            <v-col>
                              <p class="body-2 mx-2 my-2 pa-4 float-right">
                                Total Proj:
                                <span>{{
                                    calculateProjection(data.index)
                                  }}</span>
                              </p>
                            </v-col>
                          </v-row>
                        </template>

                        <!-- //? for fanduel -->
                        <template v-if="operator == 'FanDuel'">
                          <v-row>
                            <v-col>
                              <p class="body-2 mx-2 my-2 pa-4">
                                Total Salary:
                                <span
                                    v-if="calculateSalary(data.index) <= 60000"
                                    class="green--text body-2"
                                >
                                  $ {{ calculateSalary(data.index) }}
                                </span>
                                <span
                                    v-if="calculateSalary(data.index) > 60000"
                                    class="red--text body-2"
                                >
                                  $ {{ calculateSalary(data.index) }}
                                </span>
                              </p>
                            </v-col>
                            <v-col>
                              <p class="body-2 mx-2 my-2 pa-4 float-right">
                                Total Proj:
                                <span>{{
                                    calculateProjection(data.index)
                                  }}</span>
                              </p>
                            </v-col>
                          </v-row>
                        </template>
                      </v-sheet>
                    </template>
                    <!-- footer -->
                  </v-data-table>
                </div>
              </template>
            </v-virtual-scroll>
          </template>
          <!-- //* loop ends -->
        </v-col>
      </v-row>
    </v-sheet>

    <!--error modal -->
    <v-dialog v-if="isTodayBuild" v-model="isTodayBuild" max-width="300">
      <v-card>
        <v-toolbar dense color="#00E676" class="text-h6" dark>
          Get Full Access
          <v-spacer></v-spacer>

          <v-btn icon @click="isTodayBuild = !isTodayBuild">
            <v-icon color="red">mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text class="text-center text-h6 font-weight-bold pa-2">
          Upgrade to get 150 lineups !
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
              color="green darken-1 white--text"
              depressed
              @click="goToUpgrade"
          >
            Upgrade Now
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- error modal ends.. -->
  </div>
</template>

<script>
import PlayerDetails from "../Tabs/PlayerDetails.vue";
import NbaNavbar from "@/layout/NBA-panel/NbaLayout.vue";
import {guid} from "@/mixins/guid.js";
import {mapState} from "vuex";
import {SocketInstance} from "@/main";

import _ from "lodash";
// import Observer from 'vue-intersection-observer';

export default {
  name: "BuildTeam",
  components: {NbaNavbar, PlayerDetails},
  mixins: [guid],
  props: {
    slateId: {
      type: String,
      default: () => "",
    },

    operator: {
      type: String,
      default: () => "",
    },

    operatorGameType: {
      type: String,
      default: () => "",
    },

    sportType: {
      type: String,
      default: () => "",
    },

    defaultSport: {
      type: String,
      default: () => "",
    },

    defaultOptimizer: {
      type: String,
      default: () => "",
    },

    sportId: {
      type: String,
      default: () => "",
    },

    playerSwap: {
      type: [Array, Object],
      default: () => {
      },
    },

    numberOFGames: {
      type: [String, Number],
      default: 0,
    },

    seasonType: {
      type: [String, Number],
      default: "",
    },

    NumberOfBuildDesktop: {
      type: [String, Number],
      required: true,
    },

    lineupOption: {
      type: Boolean,
      required: true,
    },
  },

  data() {
    return {
      team_build: [],
      planType: this.$store.state.userModule.userState.plantype,
      new_team_build: [],
      componentKey: 0,
      // showCheckBox: false,
      playerId: "",
      sportsID: 1,
      selected_teams: [],
      isChecked: false,
      isTodayBuild: false,
      // checkBoxArr: [],
      Arr: [],
      result: [],
      isActive: false,
      select_all: false,
      remainingAmount: 0,
      isBuilding: false,
      userId: localStorage.getItem("user"),
      position: ["PG", "SG", "SF", "PF", "C", "G", "F", "UTIL"],
      selection: "PG",
      maxRule: [(v) => (v >= 0 && v <= 150) || "Max Limit: 150"],
      isSavedLineupButton: false,
      NumberOfBuild:
          this.$store.state.userModule.userState.plantype === "Free"
              ? [3]
              : [10, 20, 30, 50, 70, 90, 120, 150],
      build_no:
          this.$store.state.userModule.userState.plantype === "Free" ? 3 : 10,
      newBuildArr: [],
      j: 0,
      currentBuildSize: null,

      TeamHeaders: [
        {
          text: "Profile",
          value: "PhotoUrl",
          sortable: false,
          align: "center",
          width: "30px",
        },
        {text: "", value: "swap", sortable: false},
        {
          text: "Position",
          value: "DraftKingsPosition",
          sortable: false,
          align: "center",
          width: "30px",
        },
        // { text: 'Player', value: 'Name', sortable: false },
        {text: "Team", value: "Team", sortable: false},
        {text: "Status", value: "HomeOrAway", sortable: false},
        {text: "Salary($)", value: "DraftKingsSalary", sortable: false},
        {text: "FPPG", value: "FPPG", sortable: false},
        {text: "Proj.", value: "DraftKingsProjection", sortable: false},
      ],
    };
  },

  computed: {
    ...mapState("MlbModule", ["lastLineup"]),

    computedItemHeight() {
      if (this.operator) {
        if (
            this.operator === "DraftKings" &&
            this.operatorGameType === "Classic" &&
            this.sportId == "1"
        ) {
          return "800";
        } else if (
            this.operator === "DraftKings" &&
            this.operatorGameType === "Classic" &&
            this.sportId == "2"
        ) {
          return "950";
        } else if (
            this.operator === "DraftKings" &&
            this.operatorGameType === "Classic" &&
            this.sportId == "3"
        ) {
          return "880";
        } else if (
            this.operator === "DraftKings" &&
            this.operatorGameType === "Classic" &&
            this.sportId == "4"
        ) {
          return "850";
        } else if (
            this.operator === "DraftKings" &&
            this.operatorGameType === "Single"
        ) {
          return "650";
        } else if (
            this.operator === "FanDuel" &&
            this.operatorGameType === "Single"
        ) {
          return "650";
        } else if (
            this.operator === "FanDuel" &&
            this.operatorGameType === "Classic"
        ) {
          return "900";
        }
      }
      return 0;
    },

    setLineups() {
      if (this.team_build.allTeams) {

        console.log(
            "TEAM",
            this.lineupOption
                ? this.team_build.allTeams.slice(1)
                : this.team_build.allTeams
        );
        return this.lineupOption
            ? this.team_build.allTeams.slice(1)
            : this.team_build.allTeams;
      }
    },
  },

  methods: {
    isVisible() {
      this.$parent.hideBuildPanel();
    },

    goToUpgrade() {
      this.isTodayBuild = false;
      this.$router.push({name: "upgradePlan"});
    },

    topView() {
      console.log("top view hit");
    },

    bottomView() {
      console.log("bottom hit");
    },

    playerDetailModal(playerId, sportId) {
      this.playerId = playerId;
      this.sportsID = sportId;
      // this.dialog = true;
    },

    calculateBuild(buildNumber, initial_socket, next_socket, socket_response) {
      SocketInstance.removeAllListeners(socket_response);

      let obj = {
        SlateID: this.slateId,
        user: this.userId,
        operator: this.operator,
        gametype: this.operatorGameType,
        NoOfGames: this.numberOFGames,
      };

      let params = {
        user: this.userId,
        slatId: this.slateId,
        lineup: this.team_build.allTeams,
        operator: this.operator,
        gametype: this.operatorGameType,
        SportType: this.sportType,
        SportId: this.sportId,
      };
      let createdBuilds = {allTeams: []};
      let self = this;

      // If it's empty, push 1 as the first element
      if (self.newBuildArr.length === 0) {
        self.newBuildArr.push(1);
      }
      // create an array of equally divided number of builds...
      for (let index = 0; index < buildNumber;) {
        let lineup_size = 10;

        if (buildNumber - index <= 10) {
          lineup_size = buildNumber - index;
        }

        self.newBuildArr.push(lineup_size);
        index = index + lineup_size;
      }
      console.log("#", self.newBuildArr);

      //#
      function firstCall(i) {
        SocketInstance.emit(initial_socket, {
          ...obj,
          NumberOfBuild: self.newBuildArr[i],
          SeasonType: self.seasonType,
          Builds: [],
        });
        console.log("first call");
      }

      //#
      function nextCall(i, projection) {
        SocketInstance.emit(next_socket, {
          ...obj,
          NumberOfBuild: self.newBuildArr[i],
          SeasonType: self.seasonType,
          Builds: [],
          BestProjection: projection,
        });
        console.log("next call");
      }

      firstCall(this.j);

      // socket listening...
      SocketInstance.on(socket_response, function (res) {
        if (res) {
          if (!res.success) {
            console.log("error", res);
            self.team_build = res;
            self.j = 0;
            self.newBuildArr = [];
            self.isBuilding = false;
          }
          console.log("completeResponse", res);

          createdBuilds.allTeams.push(...res.allTeams);
          console.log("socket", createdBuilds);

          if (self.newBuildArr.length > 0) {
            self.j++;
          }
          // console.log('j', self.j, self.newBuildArr.length);
          if (self.j < self.newBuildArr.length) {
            /**Now call nextCall function with a delay as backend needs few secs to store builds in DB */
            setTimeout(() => {
              console.log("delay", res.delay);
              nextCall(self.j, res.BestProjection);
            }, res.delay);
          } else {
            self.j = 0;
            self.newBuildArr = [];

            self.team_build = createdBuilds;
            self.isSavedLineupButton = true;
            self.isBuilding = false;
            self.$store.dispatch("MlbModule/saveLastLineup", params);
          }
        }
        self.currentBuildSize = createdBuilds.allTeams.length;
      });
    },

    setBuildExposure(buildNumber, build) {
      this.$emit("buildExposure", {buildNumber, build});
    },

    checkTodayLineup(showSkeletonLoader = true) {
      this.$store
          .dispatch("userModule/checkTodayLineup", {user: this.userId})
          .then(() => {
            if (this.planType === "Free") {
              if (this.$store.state.userModule.todayLineup.success) {
                this.isTodayBuild = true;
              } else {
                this.buildTeam(showSkeletonLoader);
              }
            } else {
              this.buildTeam(showSkeletonLoader);
            }
          });
    },

    buildTeam(showSkeletonLoader = true) {
      // this.isChecked = [];
      this.team_build = [];
      
      // Show skeleton loader if called from internal button click
      if (showSkeletonLoader) {
        this.isBuilding = true;
      }
      let obj = {
        SlateID: this.slateId,
        NumberOfBuild: this.$vuetify.breakpoint.smAndDown
            ? this.build_no
            : this.NumberOfBuildDesktop,
        user: this.userId,
        operator: this.operator,
        gametype: this.operatorGameType,
        NoOfGames: this.numberOFGames,
      };
      if (this.defaultSport == "1") {
        // socket NBA
        if (this.$vuetify.breakpoint.smAndDown) {
          // check for mobile view nba...
          this.calculateBuild(
              this.build_no,
              "nbacreatebuilds",
              "nextnbacreatebuilds",
              "nbacreatebuild-success"
          );
        } else {
          this.calculateBuild(
              this.NumberOfBuildDesktop,
              "nbacreatebuilds",
              "nextnbacreatebuilds",
              "nbacreatebuild-success"
          );
        }
      } else if (this.defaultSport == "2") {
        // check for mobile view...
        if (this.$vuetify.breakpoint.smAndDown) {
          this.calculateBuild(
              this.build_no,
              "mlbcreatebuilds",
              "nextmlbcreatebuilds",
              "mlbcreatebuild-success"
          );
        } else {
          this.calculateBuild(
              this.NumberOfBuildDesktop,
              "mlbcreatebuilds",
              "nextmlbcreatebuilds",
              "mlbcreatebuild-success"
          );
        }
      } else if (this.defaultSport == "3") {
        // check for mobile view...
        if (this.$vuetify.breakpoint.smAndDown) {
          this.calculateBuild(
              this.build_no,
              "nhlcreatebuilds",
              "nextnhlcreatebuilds",
              "nhlcreatebuild-success"
          );
        } else {
          this.calculateBuild(
              this.NumberOfBuildDesktop,
              "nhlcreatebuilds",
              "nextnhlcreatebuilds",
              "nhlcreatebuild-success"
          );
        }
      } else if (this.defaultSport == "4") {
        // check for mobile view...
        if (this.$vuetify.breakpoint.smAndDown) {
          this.calculateBuild(
              this.build_no,
              "nflcreatebuilds",
              "nextnflcreatebuilds",
              "nflcreatebuild-success"
          );
        } else {
          this.calculateBuild(
              this.NumberOfBuildDesktop,
              "nflcreatebuilds",
              "nextnflcreatebuilds",
              "nflcreatebuild-success"
          );
        }
      }
    },

    calculateSalary(team_index) {
      let total_salary = 0;

      if (this.operator === "DraftKings") {
        this.setLineups[team_index].forEach(function (player) {
          total_salary += parseFloat(player.DraftKingsSalary);
        });
      } else if (this.operator === "FanDuel") {
        this.setLineups[team_index].forEach(function (player) {
          total_salary += parseFloat(player.FanDuelSalary);
        });
      }
      return total_salary.toFixed(2);
    },

    calculateProjection(team_index) {
      let total_proj = 0;

      if (this.operator == "DraftKings") {
        this.setLineups[team_index].forEach((player) => {
          total_proj += parseFloat(player.DraftKingsProjection);
        });
      } else if (this.operator == "FanDuel") {
        this.setLineups[team_index].forEach((player) => {
          total_proj += parseFloat(player.FandDualProjection);
        });
      }
      return total_proj.toFixed(2);
    },

    singleTeamSelection(team, index) {
      if (!this.selected_teams.includes(team)) {
        this.selected_teams.push(team);
      } else {
        this.selected_teams.splice(index, 1);
      }
    },

    selectAllToggle() {
      if (this.select_all) {
        this.selected_teams = this.team_build.allTeams;
      } else {
        this.selected_teams = [];
      }
      this.isChecked = !this.isChecked;
    },

    saveLineup(userId, slateId) {
      if (this.planType === "Free") {
        this.isTodayBuild = true;
      } else {
        if (this.selected_teams.length > 0) {
          let obj = {
            user: userId,
            slatId: slateId,
            lineup: this.selected_teams,
            operator: this.operator,
            gametype: this.operatorGameType,
            SportType: this.sportType,
            SportId: this.sportId,
          };
          if (this.defaultSport == "1") {
            this.$store.dispatch("NbaModule/getSaveLineup", obj);
          } else if (this.defaultSport == "2") {
            this.$store.dispatch("MlbModule/getSaveLineup", obj);
          } else if (this.defaultSport == "3") {
            this.$store.dispatch("NhlModule/getSaveLineup", obj);
          } else if (this.defaultSport == "4") {
            this.$store.dispatch("NflModule/getSaveLineup", obj);
          }
        } else {
          alert("Please select atleast one team to Save Lineups.");
        }
        // clean up
        this.selected_teams = [];
      }
    },

    removeDuplicates(list, parent_index) {
      // this.Arr = _.intersection(list, this.team_build.allTeams[parent_index]);
      // this.Arr = [...list, ...this.team_build.allTeams[parent_index]];
      // this.Arr = _.concat(list, this.team_build.allTeams[parent_index]);
      this.Arr = _.differenceBy(
          list,
          this.team_build.allTeams[parent_index],
          "PlayerID"
      );
      console.log(this.Arr);
      return this.Arr;
    },

    findPositionForNba(index) {
      if (
          this.defaultSport == "1" &&
          this.operator == "DraftKings" &&
          this.operatorGameType == "Classic"
      ) {
        switch (index) {
          case 0:
            return "PG";
          case 1:
            return "SG";
          case 2:
            return "SF";
          case 3:
            return "PF";
          case 4:
            return "C";
          case 5:
            return "G";
          case 6:
            return "F";
          case 7:
            return "UTIL";
        }
      } else if (
          this.defaultSport == "1" &&
          this.operator == "DraftKings" &&
          this.operatorGameType == "Single"
      ) {
        switch (index) {
          case 0:
            return "CPT";
          case 1:
            return "UTIL";
          case 2:
            return "UTIL";
          case 3:
            return "UTIL";
          case 4:
            return "UTIL";
          case 5:
            return "UTIL";
          default:
            break;
        }
      } else if (
          this.defaultSport == "1" &&
          this.operator == "FanDuel" &&
          this.operatorGameType == "Classic"
      ) {
        switch (index) {
          case 0:
            return "PG";
          case 1:
            return "PG";
          case 2:
            return "SG";
          case 3:
            return "SG";
          case 4:
            return "SF";
          case 5:
            return "SF";
          case 6:
            return "PF";
          case 7:
            return "PF";
          case 8:
            return "C";
        }
      } else if (
          this.defaultSport == "1" &&
          this.operator == "FanDuel" &&
          this.operatorGameType == "Single"
      ) {
        switch (index) {
          case 0:
            return "MVP - 2X Points";
          case 1:
            return "STAR - 1.5X Points";
          case 2:
            return "PRO";
          case 3:
            return "UTIL";
          case 4:
            return "UTIL";

          default:
            break;
        }
      }
    },

    findPositionForMlb(index) {
      //  ;
      if (
          this.defaultSport == "2" &&
          this.operator == "DraftKings" &&
          this.operatorGameType == "Classic"
      ) {
        switch (index) {
          case 0:
            return "P";
          case 1:
            return "P";
          case 2:
            return "C";
          case 3:
            return "1B";
          case 4:
            return "2B";
          case 5:
            return "3B";
          case 6:
            return "SS";
          case 7:
            return "OF";
          case 8:
            return "OF";
          case 9:
            return "OF";
        }
      } else if (
          this.defaultSport == "2" &&
          this.operator == "DraftKings" &&
          this.operatorGameType == "Single"
      ) {
        switch (index) {
          case 0:
            return "CPT";
          case 1:
            return "UTIL";
          case 2:
            return "UTIL";
          case 3:
            return "UTIL";
          case 4:
            return "UTIL";
          case 5:
            return "UTIL";
          default:
            break;
        }
      } else if (
          this.defaultSport == "2" &&
          this.operator == "FanDuel" &&
          this.operatorGameType == "Classic"
      ) {
        switch (index) {
          case 0:
            return "P";
          case 1:
            return "C/1B";
          case 2:
            return "2B";
          case 3:
            return "3B";
          case 4:
            return "SS";
          case 5:
            return "OF";
          case 6:
            return "OF";
          case 7:
            return "OF";
          case 8:
            return "UTIL";
        }
      } else if (
          this.defaultSport == "2" &&
          this.operator == "FanDuel" &&
          this.operatorGameType == "Single"
      ) {
        switch (index) {
          case 0:
            return "MVP - 2X Points";
          case 1:
            return "STAR - 1.5X Points";
          case 2:
            return "UTIL";
          case 3:
            return "UTIL";
          case 4:
            return "UTIL";

          default:
            break;
        }
      }
    },

    findPositionForNfl(index) {
      //  ;
      if (
          this.defaultSport == "4" &&
          this.operator == "DraftKings" &&
          this.operatorGameType == "Classic"
      ) {
        switch (index) {
          case 0:
            return "QB";
          case 1:
            return "RB";
          case 2:
            return "RB";
          case 3:
            return "WR";
          case 4:
            return "WR";
          case 5:
            return "WR";
          case 6:
            return "TE";
          case 7:
            return "FLEX";
          case 8:
            return "DST";
          default:
            break;
        }
      } else if (
          this.defaultSport == "4" &&
          this.operator == "DraftKings" &&
          this.operatorGameType == "Single"
      ) {
        switch (index) {
          case 0:
            return "CPT";
          case 1:
            return "FLEX";
          case 2:
            return "FLEX";
          case 3:
            return "FLEX";
          case 4:
            return "FLEX";
          case 5:
            return "FLEX";
          default:
            break;
        }
      } else if (
          this.defaultSport == "4" &&
          this.operator == "FanDuel" &&
          this.operatorGameType == "Classic"
      ) {
        switch (index) {
          case 0:
            return "QB";
          case 1:
            return "RB";
          case 2:
            return "RB";
          case 3:
            return "WR";
          case 4:
            return "WR";
          case 5:
            return "WR";
          case 6:
            return "TE";
          case 7:
            return "FLEX";
          case 8:
            return "DEF";
          default:
            break;
        }
      } else if (
          this.defaultSport == "4" &&
          this.operator == "FanDuel" &&
          this.operatorGameType == "Single"
      ) {
        switch (index) {
          case 0:
            return "MVP - 1.5X Points";
          default:
            return "AnyFLEX";
        }
      }
    },

    findPositionForNhl(index) {
      if (
          this.defaultSport == "3" &&
          this.operator == "DraftKings" &&
          this.operatorGameType == "Classic"
      ) {
        switch (index) {
          case 0:
            return "C";
          case 1:
            return "C";
          case 2:
            return "W";
          case 3:
            return "W";
          case 4:
            return "W";
          case 5:
            return "D";
          case 6:
            return "D";
          case 7:
            return "G";
          case 8:
            return "UTIL";
          default:
            break;
        }
      } else if (
          this.defaultSport == "3" &&
          this.operator == "DraftKings" &&
          this.operatorGameType == "Single"
      ) {
        switch (index) {
          case 0:
            return "CPT";
          case 1:
            return "FLEX";
          case 2:
            return "FLEX";
          case 3:
            return "FLEX";
          case 4:
            return "FLEX";
          case 5:
            return "FLEX";
          default:
            break;
        }
      } else if (
          this.defaultSport == "3" &&
          this.operator == "FanDuel" &&
          this.operatorGameType == "Classic"
      ) {
        switch (index) {
          case 0:
            return "C";
          case 1:
            return "C";
          case 2:
            return "W";
          case 3:
            return "W";
          case 4:
            return "D";
          case 5:
            return "D";
          case 6:
            return "UTIL";
          case 7:
            return "UTIL";
          case 8:
            return "G";
          default:
            break;
        }
      } else if (
          this.defaultSport == "3" &&
          this.operator == "FanDuel" &&
          this.operatorGameType == "Single"
      ) {
        switch (index) {
          case 0:
            return "Captain - 1.5x Pts";
          default:
            return "UTIL";
        }
      }
    },

    findPlayerPosition(index) {
      if (this.defaultSport == "1") {
        return this.findPositionForNba(index);
      } else if (this.defaultSport == "2") {
        return this.findPositionForMlb(index);
      } else if (this.defaultSport == "3") {
        return this.findPositionForNhl(index);
      } else if (this.defaultSport == "4") {
        return this.findPositionForNfl(index);
      }
    },

    fetchSwapPlayers(slateId, index, parentIndex) {
      let payload = {
        SlateID: slateId,
        position: this.findPlayerPosition(index),
        user: this.userId,
      };

      if (this.sportType == "NBA") {
        this.$store.dispatch("NbaModule/FetchSwapPlayer", payload).then(() => {
          this.Arr = this.playerSwap.Players;
          this.removeDuplicates(this.Arr, parentIndex);
        });
      } else if (this.sportType == "MLB") {
        this.$store.dispatch("MlbModule/FetchSwapPlayer", payload).then(() => {
          this.Arr = this.playerSwap.Players;
          this.removeDuplicates(this.Arr, parentIndex);
        });
      } else if (this.sportType == "NHL") {
        this.$store.dispatch("NhlModule/FetchSwapPlayer", payload).then(() => {
          this.Arr = this.playerSwap.Players;
          this.removeDuplicates(this.Arr, parentIndex);
        });
      } else if (this.sportType == "NFL") {
        this.$store.dispatch("NflModule/FetchSwapPlayer", payload).then(() => {
          this.Arr = this.playerSwap.Players;
          this.removeDuplicates(this.Arr, parentIndex);
        });
      }
    },

    // * for fetching a swap players list...
    getPlayersByIndex(index, player, parent_index, slateId) {
      this.fetchSwapPlayers(slateId, index, parent_index);
      // alert(parent_index);
      if (
          this.defaultSport == "1" &&
          this.operator == "DraftKings" &&
          this.operatorGameType == "Classic"
      ) {
        this.remainingAmount =
            parseInt(50000) -
            parseInt(this.calculateSalary(parent_index)) +
            parseInt(player.DraftKingsSalary);
      } else if (
          this.defaultSport == "1" &&
          this.operator == "DraftKings" &&
          this.operatorGameType == "Single"
      ) {
        this.remainingAmount =
            parseInt(50000) -
            parseInt(this.calculateSalary(parent_index)) +
            parseInt(player.DraftKingsSalary);
      } else if (
          this.defaultSport == "1" &&
          this.operator == "FanDuel" &&
          this.operatorGameType == "Classic"
      ) {
        this.remainingAmount =
            parseInt(60000) -
            parseInt(this.calculateSalary(parent_index)) +
            parseInt(player.FanDuelSalary);
      } else if (
          this.defaultSport == "1" &&
          this.operator == "FanDuel" &&
          this.operatorGameType == "Single"
      ) {
        this.remainingAmount =
            parseInt(60000) -
            parseInt(this.calculateSalary(parent_index)) +
            parseInt(player.FanDuelSalary);
      } else if (
          this.defaultSport == "2" &&
          this.operator == "DraftKings" &&
          this.operatorGameType == "Classic"
      ) {
        this.remainingAmount =
            parseInt(50000) -
            parseInt(this.calculateSalary(parent_index)) +
            parseInt(player.DraftKingsSalary);
      } else if (
          this.defaultSport == "2" &&
          this.operator == "DraftKings" &&
          this.operatorGameType == "Single"
      ) {
        this.remainingAmount =
            parseInt(50000) -
            parseInt(this.calculateSalary(parent_index)) +
            parseInt(player.DraftKingsSalary);
      } else if (
          this.defaultSport == "2" &&
          this.operator == "FanDuel" &&
          this.operatorGameType == "Classic"
      ) {
        this.remainingAmount =
            parseInt(35000) -
            parseInt(this.calculateSalary(parent_index)) +
            parseInt(player.FanDuelSalary);
      } else if (
          this.defaultSport == "2" &&
          this.operator == "FanDuel" &&
          this.operatorGameType == "Single"
      ) {
        this.remainingAmount =
            parseInt(35000) -
            parseInt(this.calculateSalary(parent_index)) +
            parseInt(player.FanDuelSalary);
      } else if (
          this.defaultSport == "3" &&
          this.operator == "DraftKings" &&
          this.operatorGameType == "Classic"
      ) {
        this.remainingAmount =
            parseInt(50000) -
            parseInt(this.calculateSalary(parent_index)) +
            parseInt(player.DraftKingsSalary);
      } else if (
          this.defaultSport == "3" &&
          this.operator == "DraftKings" &&
          this.operatorGameType == "Single"
      ) {
        this.remainingAmount =
            parseInt(50000) -
            parseInt(this.calculateSalary(parent_index)) +
            parseInt(player.DraftKingsSalary);
      } else if (
          this.defaultSport == "3" &&
          this.operator == "FanDuel" &&
          this.operatorGameType == "Classic"
      ) {
        this.remainingAmount =
            parseInt(55000) -
            parseInt(this.calculateSalary(parent_index)) +
            parseInt(player.FanDuelSalary);
      } else if (
          this.defaultSport == "3" &&
          this.operator == "FanDuel" &&
          this.operatorGameType == "Single"
      ) {
        this.remainingAmount =
            parseInt(55000) -
            parseInt(this.calculateSalary(parent_index)) +
            parseInt(player.FanDuelSalary);
      } else if (
          this.defaultSport == "4" &&
          this.operator == "DraftKings" &&
          this.operatorGameType == "Classic"
      ) {
        this.remainingAmount =
            parseInt(50000) -
            parseInt(this.calculateSalary(parent_index)) +
            parseInt(player.DraftKingsSalary);
      } else if (
          this.defaultSport == "4" &&
          this.operator == "DraftKings" &&
          this.operatorGameType == "Single"
      ) {
        this.remainingAmount =
            parseInt(50000) -
            parseInt(this.calculateSalary(parent_index)) +
            parseInt(player.DraftKingsSalary);
      } else if (
          this.defaultSport == "4" &&
          this.operator == "FanDuel" &&
          this.operatorGameType == "Classic"
      ) {
        this.remainingAmount =
            parseInt(60000) -
            parseInt(this.calculateSalary(parent_index)) +
            parseInt(player.FanDuelSalary);
      } else if (
          this.defaultSport == "4" &&
          this.operator == "FanDuel" &&
          this.operatorGameType == "Single"
      ) {
        this.remainingAmount =
            parseInt(60000) -
            parseInt(this.calculateSalary(parent_index)) +
            parseInt(player.FanDuelSalary);
      }
    },

    // * for swapping player from the list
    replacePlayer(new_player, swap_with_player_id, team_index) {
      // player index
      let index = this.setLineups[team_index].findIndex(
          (player) => player.PlayerID === swap_with_player_id
      );
      //console.log('index', index);

      if (index !== -1) {
        // swap the players from both arrays...
        this.$set(this.setLineups[team_index], index, new_player);
        console.log("Swap Team", this.setLineups);
      }
    },
  },
};
</script>

<style scoped>
.maximum {
  font-size: 0.8em;
  min-height: 2px;
  max-width: 130px;
  max-height: 20px;
}

/* The container */
.selection-container {
  display: block;
  position: relative;
  padding-left: 35px;
  margin-bottom: 12px;
  cursor: pointer;
  font-size: 22px;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

/* Hide the browser's default checkbox */
.selection-container input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
}

/* Create a custom checkbox */
.checkmark {
  position: absolute;
  top: 5px;
  left: 15px;
  height: 20px;
  width: 20px;
  background-color: #eee;
}

/* On mouse-over, add a grey background color */
.selection-container:hover input ~ .checkmark {
  background-color: #ccc;
}

/* When the checkbox is checked, add a blue background */
.selection-container input:checked ~ .checkmark {
  background-color: #ff9800;
}

/* Create the checkmark/indicator (hidden when not checked) */
.checkmark:after {
  content: "";
  position: absolute;
  display: none;
}

/* Show the checkmark when checked */
.selection-container input:checked ~ .checkmark:after {
  display: block;
}

/* Style the checkmark/indicator */
.selection-container .checkmark:after {
  left: 5px;
  top: 1px;
  width: 8px;
  height: 15px;
  border: solid white;
  border-width: 0 3px 3px 0;
  transform: rotate(45deg);
}

/* Skeleton loader animations */
.skeleton-fade {
  animation: skeleton-pulse 1.5s ease-in-out infinite;
}

@keyframes skeleton-pulse {
  0% {
    opacity: 1;
  }
  50% {
    opacity: 0.6;
  }
  100% {
    opacity: 1;
  }
}

/* Additional skeleton animation for shimmer effect */
.skeleton-fade::after {
  content: '';
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: linear-gradient(90deg, transparent, rgba(255,255,255,0.4), transparent);
  animation: skeleton-shimmer 2s infinite;
}

@keyframes skeleton-shimmer {
  0% {
    transform: translateX(-100%);
  }
  100% {
    transform: translateX(100%);
  }
}
</style>
